export default "__VITE_ASSET__BYxg307h__"